import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, DocumentTextIcon, UserGroupIcon, LightBulbIcon, BuildingLibraryIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';
import { Card, CardBody, Button } from '@heroui/react';
import { ReactFlowProvider } from '@xyflow/react';
import CaseSummarizer from '../components/detective/CaseSummarizer';
import InterviewAnalyst from '../components/detective/InterviewAnalyst';
import NextStepsStrategist from '../components/detective/NextStepsStrategist';
import CaseMapper from '../components/detective/CaseMapper';
import OSINTTools from '../components/detective/OSINTTools';

const FollowUp = () => {
  const navigate = useNavigate();
  const [activeComponent, setActiveComponent] = useState('OSINTTools');

  const components = {
    CaseSummarizer: { component: <CaseSummarizer />, name: 'Case Summarizer', icon: DocumentTextIcon },
    InterviewAnalyst: { component: <InterviewAnalyst />, name: 'Interview Analyst', icon: UserGroupIcon },
    NextStepsStrategist: { component: <NextStepsStrategist />, name: 'Next Steps Strategist', icon: LightBulbIcon },
    CaseMapper: { component: <CaseMapper />, name: 'Case Mapper', icon: BuildingLibraryIcon },
    OSINTTools: { component: <OSINTTools />, name: 'OSINT Tools', icon: ShieldCheckIcon },
  };

  const ActiveComponent = components[activeComponent].component;

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
      {/* Sidebar */}
      <Card className="w-64 h-full rounded-none shadow-lg">
        <CardBody className="p-0">
          <div className="p-4 border-b border-gray-200 dark:border-gray-700">
            <Button
              onClick={() => navigate(-1)}
              variant="light"
              startContent={<ArrowLeftIcon className="h-5 w-5" />}
              className="w-full justify-start text-gray-600 dark:text-gray-400"
            >
              Back
            </Button>
          </div>
          <nav className="py-2">
            {Object.keys(components).map((key) => {
              const { name, icon: Icon } = components[key];
              return (
                <Button
                  key={key}
                  onClick={() => setActiveComponent(key)}
                  variant={activeComponent === key ? "solid" : "light"}
                  color={activeComponent === key ? "primary" : "default"}
                  startContent={<Icon className="h-5 w-5" />}
                  className="w-full justify-start rounded-none px-4 py-3 min-h-12"
                >
                  {name}
                </Button>
              );
            })}
          </nav>
        </CardBody>
      </Card>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Card className="rounded-none shadow-sm border-b border-gray-200 dark:border-gray-700">
          <CardBody className="py-4 px-6">
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              {components[activeComponent].name}
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Your AI-powered investigative partner.
            </p>
          </CardBody>
        </Card>
        <main className="flex-1 overflow-y-auto p-6 bg-gray-50 dark:bg-gray-900">
          <Card className="h-full">
            <CardBody className="p-0">
              <ReactFlowProvider>
                {ActiveComponent}
              </ReactFlowProvider>
            </CardBody>
          </Card>
        </main>
      </div>
    </div>
  );
};

export default FollowUp;